import { createStyles } from '@mantine/core';
var transition = "all 0.3s ease";
var margin = "0px";
var longer = function longer(length) {
  return length && length + 4 + "px";
};
var useStyles = createStyles(function (_theme, _ref) {
  var color = _ref.color,
    padding = _ref.padding,
    length = _ref.length,
    width = _ref.width;
  return {
    root: {
      display: "inline-block",
      position: "relative",
      padding: padding + "px",
      cursor: "pointer"
    },
    target1: {
      "&:before,&:after": {
        content: '""',
        display: "block",
        position: "absolute",
        width: length + "px",
        height: length + "px",
        border: width + "px solid " + color,
        transition: transition
      },
      "&:before": {
        top: 0,
        left: 0,
        borderBottomColor: "transparent",
        borderRightColor: "transparent",
        borderTopColor: color,
        borderLeftColor: color
      },
      "&:after": {
        bottom: 0,
        right: 0,
        borderTopColor: "transparent",
        borderLeftColor: "transparent",
        borderBottomColor: color,
        borderRightColor: color
      },
      "&:hover:before": {
        width: longer(length),
        height: longer(length),
        margin: margin
      },
      "&:hover:after": {
        width: longer(length),
        height: longer(length),
        margin: margin
      }
    },
    target2: {
      "&:before,&:after": {
        content: '""',
        display: "block",
        position: "absolute",
        width: length + "px",
        height: length + "px",
        border: width + "px solid " + color,
        transition: transition
      },
      "&:before": {
        bottom: 0,
        left: 0,
        borderBottomColor: color,
        borderLeftColor: color,
        borderRightColor: "transparent",
        borderTopColor: "transparent"
      },
      "&:after": {
        top: 0,
        right: 0,
        borderTopColor: color,
        borderRightColor: color,
        borderLeftColor: "transparent",
        borderBottomColor: "transparent"
      },
      "&:hover:before": {
        width: longer(length),
        height: longer(length),
        margin: margin
      },
      "&:hover:after": {
        width: longer(length),
        height: longer(length),
        margin: margin
      }
    }
  };
});
export { useStyles as default };